module.exports = "/assets/data/a59ce5f4d6f5bf4a66a34224fca69097-EX4.data.json";